import React from "react";
import BootstrapModal from "react-bootstrap/Modal";
import { FaChevronLeft } from "react-icons/fa";
import "./Modal.css";

// React-Bootstrap keeps the modal mounted until its transition finishes.
// This prevents Bootstrap from trying to focus a DOM node React has removed.
const Modal = React.forwardRef(
  (
    {
      show,
      onHide,
      title,
      body,
      footer,
      modalName,
      backToPrevious = "",
      handleBackBtn,
      type = "modal-md",
    },
    ref,
  ) => (
    <BootstrapModal
      ref={ref}
      show={Boolean(show)}
      onHide={onHide}
      backdrop={false}
      keyboard={false}
      centered
      scrollable
      dialogClassName={type}
      className="custom-modal"
      id={modalName}
      aria-labelledby={`${modalName}Label`}
    >
      <BootstrapModal.Header>
        {backToPrevious !== "" && (
          <button
            type="button"
            className="btn back-btn btn-info"
            onClick={handleBackBtn}
          >
            <FaChevronLeft />
            {backToPrevious}
          </button>
        )}
        <BootstrapModal.Title as="h1" id={`${modalName}Label`}>
          {title}
        </BootstrapModal.Title>
        <button
          type="button"
          className="btn-close"
          onClick={onHide}
          aria-label="Close"
        />
      </BootstrapModal.Header>
      {body && <BootstrapModal.Body>{body}</BootstrapModal.Body>}
      {footer && <BootstrapModal.Footer>{footer}</BootstrapModal.Footer>}
    </BootstrapModal>
  ),
);

Modal.displayName = "Modal";

export default Modal;
